export default {
  arrives: 'Ankommer',
  journeyDuration: 'Reisetid',
}
